import { get } from "lodash";

import { displayInitials } from "src/util/personName";
import { isPersonEntityTag } from "src/util/tags";

const getPersonEntityProps = (tag, tagTypeConfig) => {
  const personEntityTag = isPersonEntityTag(
    tag?.tagTypeConfig || tagTypeConfig
  );
  if (!personEntityTag) {
    return undefined;
  }
  const person = get(tag, "tagAttributesMetaData.person");

  if (person?.avatar) {
    return {
      avatarSrc: person.avatar,
    };
  }

  if (person && displayInitials(person) !== "?") {
    return {
      initials: displayInitials(person),
    };
  }

  // Empty object keeps the default person avatar icon without passing `true`
  // (invalid for Tag `personEntity` PropTypes). Tag supplies imageAlt from label.
  return {};
};

export default getPersonEntityProps;
